// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__26LIX","inner":"Footer_inner__3-5T9"};